import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const TwitterStroke = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        d="M22.38 5.962a8.37 8.37 0 0 1-2.401.658 4.193 4.193 0 0 0 1.838-2.315 8.345 8.345 0 0 1-2.655 1.015 4.183 4.183 0 0 0-7.125 3.816A11.872 11.872 0 0 1 3.42 4.765a4.182 4.182 0 0 0-.565 2.103c0 1.45.738 2.732 1.86 3.482a4.17 4.17 0 0 1-1.895-.523v.053a4.184 4.184 0 0 0 3.355 4.102 4.21 4.21 0 0 1-1.889.072 4.184 4.184 0 0 0 3.906 2.904 8.388 8.388 0 0 1-5.193 1.791c-.337 0-.67-.02-.998-.058a11.822 11.822 0 0 0 6.409 1.879c7.692 0 11.897-6.373 11.897-11.9 0-.18-.005-.362-.013-.541a8.502 8.502 0 0 0 2.085-2.164l.002-.003Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
        fill={"none"}
      />

      {/* <Path
        d="M22.38 5.96193C21.6305 6.29416 20.8254 6.51863 19.979 6.6201C20.8425 6.1029 21.5049 5.28221 21.8172 4.30529C21.0094 4.78477 20.1146 5.13316 19.1622 5.31993C18.3993 4.50822 17.3133 4 16.1105 4C13.802 4 11.9297 5.87304 11.9297 8.18425C11.9297 8.51109 11.9674 8.82895 12.0374 9.13604C8.56116 8.96094 5.48164 7.29532 3.41904 4.76502C3.06002 5.38457 2.85358 6.1029 2.85358 6.86792C2.85358 8.31894 3.59227 9.60026 4.71332 10.35C4.02759 10.3276 3.38314 10.1399 2.81947 9.82653V9.8804C2.81947 11.907 4.26006 13.5977 6.17365 13.982C5.82181 14.0772 5.45291 14.1275 5.07235 14.1275C4.80308 14.1275 4.5401 14.1024 4.28519 14.0539C4.81744 15.715 6.36124 16.9254 8.19137 16.9577C6.75976 18.0801 4.95656 18.749 2.99809 18.749C2.6606 18.749 2.32761 18.7293 2 18.6907C3.85077 19.8786 6.048 20.57 8.40858 20.57C16.1007 20.57 20.3057 14.1966 20.3057 8.66912C20.3057 8.48954 20.3013 8.30816 20.2932 8.12858C21.11 7.53776 21.819 6.80237 22.3782 5.96462L22.38 5.96193Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="round"
        fill={"none"}
      /> */}
    </Icon>
  );
};

export default TwitterStroke;
